import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import routes from './routes'
import { sync } from 'vuex-router-sync'
import store from './store'
import NSSConsole from 'nss-console'
import VueResize from 'vue-resize'
import './polyfill/requestAnimation.js'

// import config from './config'
// console.image('http://localhost:8080/assets/ui/header/logoTranspa.png', 0.3)

NSSConsole.image('http://not-so-stupid.com/assets/images/logonoir.png', 0.5).then(() => {
  NSSConsole.message('Développé par l\'équipe Not-So-Stupid !')
  NSSConsole.message('http: //not-so-stupid.com')
  NSSConsole.message('contact@not-so-stupid.com')
})
Vue.config.productionTip = false
Vue.use(VueResize)
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.filter('truncate', function (value, stop, clamp) {
  if (!value) return ''
  return value.slice(0, stop) + (stop < value.length ? clamp || '...' : '')
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('uppercase', function (value) {
  if (!value) return ''
  return value.toUpperCase()
})
let locale = navigator.language.substr(0, 2)
// console.log('locale', locale)
if (locale !== 'fr' && locale !== 'en') {
  locale = 'en'
}
const pathLang = window.location.pathname.substring(1, 3)
// console.log('pathLang', pathLang)
if (pathLang === 'en' || pathLang === 'fr') {
  locale = pathLang
}
// console.log('locale', locale)
export const i18n = new VueI18n({
  locale: locale
})
const router = new VueRouter({
  base: '/',
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})
sync(store, router)

new Vue({
  i18n,
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app')

if (typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined') {
  document.body.className += ' no-mix-blend-mode'
}
